(function () {
    'use strict';

    angular.module("imApp").factory("deliveryTermLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 1534,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 1535,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
